/**
 * VulnerabilitySummary Component
 *
 * Displays open vulnerability counts by severity level using RiskTag components.
 * Shows critical, high, medium, low, info, and exposure risk counts.
 */

import { RiskTag } from '@/components/chariot-ui';

import { RiskCombinedStatusCount } from '@/types';

export interface VulnerabilitySummaryProps {
  riskCounts: RiskCombinedStatusCount;
}

export function VulnerabilitySummary({
  riskCounts,
}: VulnerabilitySummaryProps) {
  return (
    <div className="flex w-full items-center justify-between gap-3">
      <div className="flex flex-col justify-between gap-3">
        <p className="text-lg font-bold">Open Vulnerabilities</p>
        <div className="flex w-full justify-between gap-2">
          <RiskTag
            severity="critical"
            prefix={riskCounts?.['OC']?.toString() || '0'}
            size="sm"
          />
          <RiskTag
            severity="high"
            prefix={riskCounts?.['OH']?.toString() || '0'}
            size="sm"
          />
          <RiskTag
            severity="medium"
            prefix={riskCounts?.['OM']?.toString() || '0'}
            size="sm"
          />
          <RiskTag
            severity="low"
            prefix={riskCounts?.['OL']?.toString() || '0'}
            size="sm"
          />
          <RiskTag
            severity="info"
            prefix={riskCounts?.['OI']?.toString() || '0'}
            size="sm"
          />
          <RiskTag
            severity="exposure"
            prefix={riskCounts?.['OE']?.toString() || '0'}
            size="sm"
          />
        </div>
      </div>
    </div>
  );
}
